import { DateTime } from "luxon";
import {
  _throw,
  IllegalArgumentError,
  IllegalStateError,
} from "shared-ts-utils-core";
import {
  DateObjectUnits,
  DateTimeJSOptions,
  DateTimeOptions,
  DateTimeUnit,
  ToISOTimeOptions,
} from "luxon";
import { DateTimeISO } from "shared-ts-types";

export class DateTimeUtils {
  static toTruncatedIso(time: DateTime, unit: DateTimeUnit): string {
    switch (unit.toLowerCase()) {
      case "year":
        return time.year.toString();
      case "quarter":
        return time.toFormat("yyyy-qq");
      case "month":
        return time.toFormat("yyyy-LL");
      case "week":
        return time.toFormat("yyyy-WW");
      case "day":
        return time.toFormat("yyyy-LL-dd");
      case "hour":
        return time.toFormat("yyyy-LL-ddTHH");
      case "minute":
        return time.toFormat("yyyy-LL-ddTHH:mm");
      case "second":
        return time.toFormat("yyyy-LL-ddTHH:mm:ss");
      case "millisecond":
        return time.toFormat("yyyy-LL-ddTHH:mm:ss:SSS");
    }
    throw new IllegalArgumentError(`Unsupported unit: ${unit}`);
  }
  static toIso(obj: DateTime, opts?: ToISOTimeOptions): DateTimeISO {
    return (
      obj.toISO() ?? _throw(new IllegalStateError(`Invalid DateTime: ${obj}`))
    );
  }

  static toUtcIso(obj: DateTime, opts?: ToISOTimeOptions): DateTimeISO {
    return (
      obj.toUTC().toISO() ??
      _throw(new IllegalStateError(`Invalid DateTime: ${obj}`))
    );
  }
  static fromISO(text: string, opts?: DateTimeOptions): DateTime<true> {
    return (DateTime.fromISO(text, opts) ??
      _throw(
        new IllegalStateError(`Invalid DateTime: ${text}`)
      )) as DateTime<true>;
  }

  static fromMillis(millis: number, opts?: DateTimeOptions): DateTime<true> {
    return (DateTime.fromMillis(millis, opts) ??
      _throw(
        new IllegalStateError(`Invalid DateTime: ${millis}`)
      )) as DateTime<true>;
  }

  static fromObject(
    obj: DateObjectUnits,
    opts?: DateTimeJSOptions
  ): DateTime<true> {
    return (DateTime.fromObject(obj, opts) ??
      _throw(
        new IllegalStateError(`Invalid DateTime: ${obj}`)
      )) as DateTime<true>;
  }
}
